import ParseUrl from "./lib/ParseUrl";
import localforage from "localforage";

const urlContext = ParseUrl();
const { apiUrl, taskId, credKey } = urlContext;
const appSelector = "root";

let elem = document.getElementById( appSelector);

localforage.config({
					   driver: localforage.INDEXEDDB,
					   name: "FMA",
					   version: 1.0,
					   storeName: "appData"
				   });

const getConfigForComponent = (data, component) =>
	data.wedat.views.find((view) => view.component === component);

/**
 * Due to bug in Simone Plugin
 */
const cleanup = () => {
	elem.remove();
	let htmlDivElement = document.createElement("div");
	htmlDivElement.setAttribute("id", "root");

	document.body.appendChild(htmlDivElement);
	elem = document.getElementById( appSelector);
};

export {
	localforage,
	apiUrl,
	credKey,
	taskId,
	appSelector,
	elem,
	cleanup,
	getConfigForComponent,
	urlContext
};
